import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
`;

export const TooltipHeader = styled.div`
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const TooltipRowTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  color: ${colors.grey5};
`;

export const TooltipRowValue = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 19px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const TooltipRow = styled.div`
  display: grid;
  grid-template-columns: minmax(100px, 100px) 1fr;
  padding: 2px;
  width: 100%;
`;

export const TooltipItem = styled.div`
  display: flex;
  align-items: center;

  ${TooltipRowTitle} {
    margin-right: 10px;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 24px 32px;
`;

export const HeaderDropdownContainer = styled.div`
  width: 120px;
`;

export const HeaderLabel = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 28px;
  font-weight: 500;
  color: #333333;
  margin-right: 16px;
`;

export const ChartContainer = styled.div`
  position: absolute;
  top: 132px;
`;

export const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const ChartDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 184px;
  left: 220px;
  width: 112px;
  height: 64px;
`;

export const ChartDescriptionMain = styled.span`
  font-size: 33px;
  font-weight: 500;
  letter-spacing: 0.3px;
  color: ${colors.grey8};
`;

export const ChartDescriptionSecondary = styled.span`
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.3px;
  color: ${colors.grey8};
`;

export const NoPermissions = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
`;
